var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"loading-container",staticClass:"loading-container",class:{
		'loading-container--inline': _vm.inline,
	}},[(!_vm.hideLabel)?_c(_vm.inline ? 'span' : 'p',{tag:"component",staticClass:"label"},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.$t('loader.loading'))+" ")])],2):_vm._e(),_c('div',{staticClass:"spinner",class:{
			'spinner--large': _vm.size === _vm.Size.LARGE,
			'spinner--medium': _vm.size === _vm.Size.MEDIUM,
			'spinner--small': _vm.size === _vm.Size.SMALL,
		}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }